<template>
	<div>
		<div class="col-md-4 pt-3 centre_sm_none" :class="{'d-sm-block':viewToggle||!clickToggle,'d-none':viewToggle||!clickToggle}">
			<div class="right_list_content">
				<div style="line-height: 65px;">
					<p id="right_content_title_information" class="pl-3 mb-0">
						<i class="fa fa-book fa-lg mr-2"></i>案例
                        <button class="btn genceback float-right mt-3" @click="reset">重置</button>
					</p>
				</div>
                <div>
					<div class="d-flex flex-wrap right_information_dropdown">

						<div class="text-muted flex-fill col-4 m-0">
							<div class="dropdown">
								<li class="dropdown-toggle" data-toggle="dropdown">
									<span class="beyond_one">{{this.nationsSelected}}</span>
								</li>
								<div class="dropdown-menu nano statenano" style="height: auto;">

									<div class="nano-content nano-contents">

										<a class="dropdown-item" v-for="(value, key) in nations" @click="filtrateState(value)" href="javascript:">{{value}}</a>

									</div>
								</div>
							</div>
						</div>
						<div class="col-4 m-0 text-muted flex-fill">
							<div class="dropdown">
								<li class="dropdown-toggle" data-toggle="dropdown">
									<span class="beyond_one">{{this.classifysSelected}}</span>
								</li>
								<div class="dropdown-menu nano" style="height: auto;width: 195px;">

									<div class="nano-content nano-contents">
										<a class="dropdown-item" v-for="(value, key) in classifys" @click="filtrateClassifys(value)" href="javascript:">{{value}}</a>
									</div>
								</div>
							</div>
						</div>
						<div class="col-4 m-0 text-muted flex-fill">
							<div class="dropdown">
								<li class="dropdown-toggle" data-toggle="dropdown">
									<span class="beyond_one">{{this.industrysSelected}}</span>
								</li>
								<div class="dropdown-menu nano" style="height: auto;width: 300px;">

									<div class="nano-content nano-contents">
										<a class="dropdown-item" v-for="(value, key) in industrys" @click="filtrateindustry(key,value)" href="javascript:">{{value}}</a>
									</div>

								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row nano video_breviary m-0 information_list wenzlist">
					<div class="nano-content" id="home_right_list" :class="{'cur':!viewToggle}">
						<ul class="list-unstyled">

							<li v-for="probation in probations" v-if="probations" class="media pb-4 pt-4 pl-4 pr-3 border-bottom probation_back">

								<img v-if="probation.thumb!=''" class="mr-3 img-thumbnail probations_img" :src="probation.thumb" />
								<div class="media-body">
									<h5>
										<router-link class="f15 text-dark font-weight-bold" :value="probation.id" :to ="{name:'caseId',params :{contentid:probation.id,psn:123}}">{{ probation.title }}</router-link>
									</h5>
									<div class="clearfix" style="line-height: 22px;">
										<div class="float-left">
											<span class="border border-primary text-primary f12 p-11" @click="filtrateClassifys(probation.catName)"><a href="javascript:">{{ probation.catName }}</a></span>
										</div>
										<div class="float-left pr-3 pl-3" v-if="probation.description">
											<img src="../../../assets/images/silkRoadBase/Vertical_barsm.png">
										</div>
										<div class="float-left" v-if="probation.description">
											<span class="f12 text-muted">{{timeDiff(probation.published)}}</span>
										</div>
									</div>
								</div>
							</li>

							<li v-for="homeList in homeLists" class="media pb-4 pt-4 pl-4 pr-3 border-bottom">

								<img v-if="homeList.thumb!=''" class="mr-3 img-thumbnail probations_img" :src="subImage(homeList.thumb)" />
								<div class="media-body">
									<h5>
										<router-link class="f15 text-dark font-weight-bold" :to ="{name:'caseId',params :{contentid:subContentId(homeList.resourceId)}}">{{ homeList.title }}</router-link>
									</h5>

									<div  class="media-foot f13 mt-3 mb-3 font-weight-light text-muted">
										<span>{{ homeList.description}}</span>
									</div>

									<div class="clearfix" style="line-height: 22px;">
										<div class="float-left">
											<span class="border border-primary text-primary f12 p-11" @click="filtrateClassifys(homeList.catName)"><a href="javascript:">{{ homeList.catName }}</a></span>
										</div>
										<div class="float-left pr-3 pl-3" v-if="homeList.description">
											<img src="../../../assets/images/silkRoadBase/Vertical_barsm.png">
										</div>
										<div class="float-left" v-if="homeList.description">
											<span class="f12 text-muted">{{timeDiff(homeList.published)}}</span>
										</div>
									</div>
								</div>
							</li>

                            <p class="text-center" v-if="loadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
							<!--<p class="text-center"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>-->
							<!--<div v-if="this.homeLists == ''">

								<p class="text-center p-2">此栏目暂时无数据....</p>

							</div>-->

						</ul>
                        <div v-if="endShow" class="w-100">
                            <p class="text-center p-2">此栏目暂时无数据....</p>
                        </div>
                        <div v-if="homeLists.length ==0&&probations.length==0" class="nodata text-center">
                            <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100"  alt="">
                            <p class="text-center p-2">暂无数据</p>

                        </div>
					</div>
				</div>

			</div>
		</div>
		<div class="col-md-8 pl-0 mt-3 centre_sm_none" :class="{'d-sm-block':viewToggle||clickToggle,'d-none':viewToggle||clickToggle}">

			<articles></articles>

		</div>


	</div>
</template>
<script>
	import articles from './ArticleDetails/Article.vue'
	export default({
		name: 'case',
		data: function() {
			return {
				nations: [],
				classifys: [],
				industrys: [],
				homeLists: [],
				probations: [], //试读
				nationsSelected: '全球',
				classifysSelected: '全部分类',
				industrysSelected: '全部行业',
				industryID: '0', //分类ID
				page: 0,
				total_page: 1,
				probationes: [],
//				detailes: [],
				firstlist:'',
				token: '',
                viewToggle:true,
                clickToggle:true,
                loadShow: true,
                endShow:false
			}
		},
		created: function() {
			var self = this;
			let that = this;
            this.viewToggle=this.IsPC();
			//首页左侧试读列表请求
			this.$axios.post('/api/pc/gettryreadarticle', {
				id: this.$route.params.id
			}).then(data => {
				var probations = data.data.data;
				that.probations = probations;

			})

			//请求select框
			this.$axios.post('/api/pc/getquery').then(data => {
				var nations = data.data.data.nation; //国家
				var industrys = data.data.data.industry; //行业
				self.nations = nations;
				self.industrys = industrys;
			})
			this.$axios.post('/api/pc/getcategory', {
				id: this.$route.params.id
			}).then(data => {
                var classifys = data.data.data.classify; //分类
                self.classifys = classifys;
                self.classifysSelected = data.data.data.category_name;
                self.loadShow = false;
                //首页左侧列表请求
                this.$axios({
                    url: 'https://recommend.imsilkroad.com/recommend/rest/tag/1/0/0/0/'+ encodeURI(self.classifysSelected) +'/0',
                    method: 'get',
                    headers: {
                        token: that.token
                    }
                }).then(data => {
                    var homeLists = data.data.results;
                    self.token = data.data.token;
                    self.homeLists = homeLists;
                    self.total_page = data.data.totalPage;

                    self.$router.push({
                        name: 'caseId',
                        params: {
                            contentid: this.$route.params.contentid ? this.$route.params.contentid : self.subContentId(homeLists[0].resourceId)
                        }
                    });
                })
			})
		},

		mounted() {
			document.getElementById('home_right_list').addEventListener('scroll', this.handleScroll);
			this.load();
		},
		methods: {
            clickToggles(){
                this.clickToggle=false;
            },
            goback(){
                if(this.viewToggle){
                    // this.$router.push({name:'consult_particulars_organization',params :{id:"10",type:1}})
                }else{
                    this.clickToggle=true;
                }

            },
			filtrateState: function(e) { //国家
				this.reveal = true;
				let that = this;
				that.nationsSelected = e;

				var column = encodeURI(e); //全部国家
				var classify = encodeURI(that.classifysSelected); //全部分类
				var industry = that.industryID; //全部行业
				if(e == '全球') {
					column = 0;
				}
				if(that.classifysSelected == '全部分类') {
					classify = '案例';
				}
				this.$axios({
					url: 'https://recommend.imsilkroad.com/recommend/rest/tag/1/0/0/' + column + '/' + classify + '/' + industry,
					method: 'get'
				}).then(data => {
					that.homeLists = data.data.results;
					that.token = data.data.token;
					that.total_page = data.data.totalPage;
				}, function(response) {
					console.info(response);
					if(response) {
						console.log("失败");
					}
				})
			},
			filtrateClassifys: function(e) { //分类
				this.reveal = true;
				let that = this;
				that.classifysSelected = e;
				var column = encodeURI(that.nationsSelected); //全部国家
				var classify = encodeURI(e); //全部分类
				var industry = that.industryID; //全部行业
				if(that.nationsSelected == '全球') {
					column = 0;
				}
				if(e == '全部分类') {
					classify = '案例';
				}
				this.$axios({
					url: 'https://recommend.imsilkroad.com/recommend/rest/tag/1/0/0/' + column + '/' + classify + '/' + industry,
					method: 'get'
				}).then(data => {
					that.homeLists = data.data.results;
					that.token = data.data.token;
					that.total_page = data.data.totalPage;
				}, function(response) {
					console.info(response);
					if(response) {
						console.log("失败");
					}
				})
			},
			filtrateindustry: function(e, val) { //行业
				this.reveal = true;
				let that = this;
				var column = encodeURI(that.nationsSelected); //全部国家
				var classify = encodeURI(that.classifysSelected); //全部分类
				var industry = e; //全部行业
				that.industryID = e;
				that.industrysSelected = val;
				if(that.nationsSelected == '全球') {
					column = 0;
				}
				if(that.classifysSelected == '全部分类') {
					classify = '案例';
				}
				this.$axios({
					url: 'https://recommend.imsilkroad.com/recommend/rest/tag/1/0/0/' + column + '/' + classify + '/' + industry,
					method: 'get'
				}).then(data => {
					that.homeLists = data.data.results;
					that.token = data.data.token;
					that.total_page = data.data.totalPage;
				}, function(response) {
					console.info(response);
					if(response) {
						console.log("失败");
					}
				})
			},
			handleScroll() {
				var industry ;
				var column ;
				var classify ;
				if(this.nationsSelected == '全球'){
					column = 0;
				} else {
                    column = this.nationsSelected;
                }
				if(this.classifysSelected == '全部分类'){
					classify = '案例';
				} else {
                    classify = this.classifysSelected;
                }
				if(this.industrysSelected == '全部行业'){
					industry = 0;
				} else {
                    industry = this.industryID;
                }
				var top = document.getElementById('home_right_list').scrollTop; // 滚动条到上面的距离
				var client = document.getElementById('home_right_list').clientHeight; // 可视区域的高度
				var all = document.getElementById('home_right_list').scrollHeight; // 总高度

				if(((all - 20) < (top + client)) && !this.loadShow) {
					this.page++;
					if(this.page > this.total_page) {
					    this.endShow = true;
						return;
					}
					this.loadShow = true;
                    var self = this;
					this.$axios({
						url: 'https://recommend.imsilkroad.com/recommend/rest/tag/1/0/' + this.page + '/' + column + '/' + classify + '/' + industry,
						method: 'get',
						headers: {
							token: self.token
						}

					}).then(data => {
						var homeListes = data.data.results;
						JSON.stringify(homeListes);
						self.token = data.data.token;
						var new_homeLists = self.homeLists.concat(homeListes);
						self.homeLists = new_homeLists;
						self.total_page = data.data.totalPage;
						self.loadShow = false;
					}, function(response) {
						console.info(response);
					})
				}

			},
			timeDiff(published) {
                var now = new Date();
                var date3 = now.getTime() - published;

                // 计算相差年数
                var years =  Math.floor(date3 / (356 * 24 * 3600 * 1000))
                //计算出相差天数
                var days = Math.floor(date3 / (24 * 3600 * 1000))
                //计算出小时数
                var hours = Math.floor(date3 / (3600 * 1000))
                //计算相差分钟数
                var minutes = Math.floor(date3 / (60 * 1000))
                // 计算相差秒数
                var seconds = Math.floor(date3 / 1000)

                if (years > 0) {
                    var time = new Date(published);
                    var y = time.getFullYear();
                    var m = time.getMonth()+1;
                    var d = time.getDate();
                    return y + '-' + m + '-' + d;
                }

                if(days > 0) {
                    if (days > 7) {
                        var time = new Date(published);
                        var y = time.getFullYear();
                        var m = time.getMonth()+1;
                        var d = time.getDate();
                        return m + '-' + d;
                    } else {
                        if(days==1){
                            return days + 'day ago';
                        }
                        return days + 'days ago';
                    }
                }

                if(hours > 0) {
                    if(hours==1){
                        return hours + 'hour ago';
                    }
                    return hours + 'hours ago';
                }

                if(minutes > 0) {
                    if(minutes==1){
                        return minutes + 'minute ago';
                    }
                    return minutes + 'minutes ago';
                }
                if (seconds > 0) {
                    if(seconds==1){
                        return  seconds + 'second ago';
                    }
                    return  seconds + 'seconds ago';
                }
            },
            subContentId(contentid) {
                // 查找 站点是否存在
                var start = contentid.indexOf('_');

                if (start > 0) {
                    var arr = contentid.split('_');
                    return arr[1];
                } else {
                    return contentid;
                }

            },
            reset:function() {
                var that = this;
                that.nationsSelected = '全球';
                that.classifysSelected = '全部分类';
                that.industrysSelected = '全部行业';
                //首页左侧列表请求
                var classify = encodeURI('案例');
                this.$axios({
                    url: 'https://recommend.imsilkroad.com/recommend/rest/tag/1/0/0/0/' + classify + '/0',
                    method: 'get',
                    headers: {
                        token: that.token
                    }
                }).then(data => {
                    var homeLists = data.data.results;
                    that.token = data.data.token;
                    that.homeLists = homeLists;
                    that.total_page = data.data.totalPage;
                    that.$router.push({
                        name: 'caseId',
                        params: {
                            contentid: self.subContentId(homeLists[0].resourceId)
                        }
                    });

                })
            },
            subImage(thumb) {
                // 处理组图的显示
                var start = thumb.indexOf('|');

                if (start > 0) {
                    var arr = thumb.split('|');
                    return arr[1];
                } else {
                    return thumb;
                }
            }

		},
		watch: {
			$route: {
				handler: function(val, oldVal) {
					var self = this;
					let that = this;

					if(this.$route.params.contentid) {

					} else {
						this.$axios.post('/api/pc/gettryreadarticle', {
							id: this.$route.params.id
						}).then(data => {
							var probations = data.data.data;
							self.probations = probations;

							//首页左侧列表请求
							var classify = encodeURI('案例');
							this.$axios({
								url: 'https://recommend.imsilkroad.com/recommend/rest/tag/1/0/0/0/' + classify + '/0',
								method: 'get',
								headers: {
									token: that.token
								}
							}).then(data => {
								var homeLists = data.data.results;

								if(that.probations == '') {

									that.$router.push({
										name: 'caseId',
										params: {
											contentid: homeLists[0].resourceId,
											psn: homeLists[0].psn
										}
									});
								} else {
									that.$router.push({
										name: 'caseId',
										params: {
											contentid: probations[0].id,
											psn: 123
										}
									});
								}

							})
						})
					}

				},
				deep: true
			}
		},
		components: {
			articles
		}
	})
</script>
<style scoped type="text/css">
    .nano > .nano-contents{
        position:relative;
        max-height:440px;
        margin: auto!important;
    }
    #home_right_list.cur{
        position: absolute;
        overflow: scroll;
        overflow-x: hidden;
        bottom: 0;
        height: inherit;
    }
</style>
